/**
 * Description: Smart Start Theme Scripts File
 * Author: Global IID
 * Version: 1.0.0
 * License: GNU General Public License v2 or later
 * License URI: http://www.gnu.org/licenses/gpl-2.0.html
 */

function gfFieldHasValue(field) {
  if (!field) {
    return false;
  }

  if (field.matches('select')) {
    return gfSelectHasValue(field);
  }

  if (field.matches('input[type="checkbox"], input[type="radio"]')) {
    return field.checked;
  }

  if (typeof field.value !== 'string') {
    return false;
  }

  var rawValue = field.value.trim();
  if (!rawValue) {
    return false;
  }

  if (field.matches('input[type="tel"]')) {
    // Ignore mask placeholders such as "(___) ___-____".
    return /[0-9]/.test(rawValue);
  }

  return /[^\s_]/.test(rawValue);
}

function gfSelectHasValue(field) {
  var selectedOptions = field.selectedOptions || [];
  for (var i = 0; i < selectedOptions.length; i++) {
    var option = selectedOptions[i];
    if (option.value && option.value.trim() !== '') {
      return true;
    }
  }

  return false;
}

function gfUpdateFloatingLabelState(field) {
  var gfield = field && field.closest ? field.closest('.gfield') : null;
  if (!gfield) {
    return;
  }

  var valueFields = gfield.querySelectorAll(
    'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea, select'
  );
  var hasValue = gfFieldListHasValue(valueFields);
  gfield.classList.toggle('ss-field-has-value', hasValue);
}

function gfFieldListHasValue(fields) {
  for (var i = 0; i < fields.length; i++) {
    if (gfFieldHasValue(fields[i])) {
      return true;
    }
  }

  return false;
}

function gfUpdateSubfieldLabelState(field) {
  if (!field || !field.closest) {
    return;
  }

  var subfieldWrap = field.closest('.ginput_complex span, .ginput_complex > div');
  if (!subfieldWrap) {
    return;
  }

  var hasSubLabel = subfieldWrap.querySelector('.gform-field-label--type-sub');
  if (!hasSubLabel) {
    return;
  }

  subfieldWrap.classList.toggle('ss-subfield-has-value', gfFieldHasValue(field));
}

function gfSyncAllFloatingLabelStates(root) {
  root = root || document;
  var groups = root.querySelectorAll('.gform-theme--framework .gfield, .gform_wrapper .gfield');
  gfForEach(groups, function(gfield) {
    gfUpdateFloatingLabelState(gfield);
  });
  gfForEach(root.querySelectorAll('.gform-theme--framework .gfield .ginput_complex input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), .gform-theme--framework .gfield .ginput_complex textarea, .gform-theme--framework .gfield .ginput_complex select, .gform_wrapper .gfield .ginput_complex input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), .gform_wrapper .gfield .ginput_complex textarea, .gform_wrapper .gfield .ginput_complex select'), function(field) {
    gfUpdateSubfieldLabelState(field);
  });
}

function gfForEach(nodeList, callback) {
  for (var i = 0; i < nodeList.length; i++) {
    callback(nodeList[i], i);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  gfSyncAllFloatingLabelStates();
});

document.addEventListener('input', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('change', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('keyup', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield input[type="tel"], .gform_wrapper .gfield input[type="tel"], .gform-theme--framework .gfield textarea, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('blur', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield input[type="tel"], .gform_wrapper .gfield input[type="tel"], .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
    gfUpdateFloatingLabelState(event.target);
    gfUpdateSubfieldLabelState(event.target);
  }
}, true);

document.addEventListener('focus', function(event) {
  if (event.target && event.target.matches('.gform-theme--framework .gfield input, .gform-theme--framework .gfield textarea, .gform-theme--framework .gfield select, .gform_wrapper .gfield input, .gform_wrapper .gfield textarea, .gform_wrapper .gfield select')) {
  }
}, true);

if (window.jQuery) {
  window.jQuery(document).on('gform_post_render gform_page_loaded', function() {
    gfSyncAllFloatingLabelStates();
  });
}

/**
 * OneTrust Global Dynamic Video Consent Tracker with HTML Preference Triggers
 */
// This function handles everything for our video cookie check
function checkVideoCookies() {
    
    // 1. Find all video blocks (gs-video youtube classes are always present on these)
    var videoBlocks = document.querySelectorAll('.gs-video.youtube');
    
    // 2. Check if OneTrust variables exist and if they contain the 'C0004' video cookie group
    var hasConsent = false;
    if (window.OnetrustActiveGroups) {
        if (window.OnetrustActiveGroups.includes('C0004')) {
            hasConsent = true; // The user has allowed video cookies!
        }
    }

    // 3. Loop through every single video block found on the page one by one
    for (var i = 0; i < videoBlocks.length; i++) {
        var currentBlock = videoBlocks[i];

        // 4. Look inside the current video block to see if our text overlay already exists
        var existingOverlay = currentBlock.querySelector('.video-consent-overlay');

        // 5. If the text overlay does NOT exist yet, let's create it and add it
        if (existingOverlay === null) {
            
            // Create a brand new HTML 'div' element
            var newOverlay = document.createElement('div');
            
            // Give our new div the class name we styled in our CSS file
            newOverlay.className = 'video-consent-overlay';
            
            // Drop your exact HTML text and link structure inside it
            newOverlay.innerHTML = 'This video requires cookies to play<br> <span class="ot-sdk-show-settings optanon-show-settings" style="font-weight:300;font-size:12px;cursor:pointer;text-decoration:underline;"> Manage cookie settings </span>';
            
            // Find the clickable text span we just created inside the overlay
            var clickLink = newOverlay.querySelector('.ot-sdk-show-settings');
            
            // Tell the browser what to do when someone clicks that text link
            clickLink.onclick = function() {
                // If OneTrust is loaded on the page, force the settings panel to open up
                if (window.OneTrust) {
                    window.OneTrust.ToggleInfoDisplay();
                }
            };

            // Physically put our newly built text overlay inside the video block container
            currentBlock.appendChild(newOverlay);
        }

        // 6. Finally, add or remove the 'consent-approved' class based on the cookie status
        if (hasConsent === true) {
            currentBlock.classList.add('consent-approved'); // This triggers the CSS that hides the text box
        } else {
            currentBlock.classList.remove('consent-approved'); // This triggers the CSS that shows the text box
        }
    }
}

// Run our check immediately when the webpage finishes loading its layout structure
window.addEventListener("DOMContentLoaded", checkVideoCookies);

// Run our check automatically after a split second fallback delay to catch slower loading elements
setTimeout(checkVideoCookies, 400);

// Run our check immediately whenever a user clicks "Accept" or changes choices inside the OneTrust banner
window.addEventListener("OneTrustGroupsUpdated", checkVideoCookies);


document.addEventListener('click', function (event) {
  document.querySelectorAll('.gspbsearch-box').forEach(function (box) {
    if (box.contains(event.target)) {
      return;
    }
    box.classList.remove('active', 'expanded');
  });
});